const dreamBedsForm = () => {
  jQuery(document).ready(function($) {
    // Function to format the price with a comma separator
    const formatPriceWithComma = function(price) {
      return price.toLocaleString('en-US');
    };

    // Function to calculate and set the bed price
    const calculateBedPrice = function(dreamBedChoice, quantity) {
      let prices = '';
      const typeVal = $('form.wpcf7-form input[type="radio"][name="radio-437"]:checked').val();
      const totalPrice = totalPriceWrapper.find('span.dreambeds-total-price');
      const totalPriceValue = $('form.wpcf7-form input[type="hidden"][name="total-price"]');

      // Price list
      if (typeVal == 'Base & Mattress Combination (Ensemble)') {
        prices = {
          'Single (92 x 188 cm)': $('.single-ensemble').text().replace(/\$/g, ''),
          'King Single (107 x 204 cm)': $('.king-single-ensemble').text().replace(/\$/g, ''),
          'Double (137 x 188 cm)': $('.double-ensemble').text().replace(/\$/g, ''),
          'Queen (153 x 204 cm)': $('.queen-ensemble').text().replace(/\$/g, ''),
          'King (183 x 204 cm)': $('.king-ensemble').text().replace(/\$/g, ''),
          'Split King (184 x 204 cm)': $('.split-king-ensemble').text().replace(/\$/g, ''),
          'Double (138 x 188 cm)': $('.nz-double-ensemble').text().replace(/\$/g, ''),
          'Queen (153 x 203 cm)': $('.nz-queen-ensemble').text().replace(/\$/g, ''),
          'King (168 x 203 cm)': $('.nz-king-ensemble').text().replace(/\$/g, ''),
          'Super King (183 x 203 cm)': $('.super-king-ensemble').text().replace(/\$/g, ''),
          'Super King - Split (Velcro join - 183 x 203 cm)': $('.super-king-split-ensemble').text().replace(/\$/g, ''),
          'Super King - Split (Zip join - 183 x 203 cm)': $('.super-king-split-ensemble').text().replace(/\$/g, ''),
        };
      } else if (typeVal == 'Mattress Only') {
        prices = {
          'Single (92 x 188 cm)': $('.single-mattress-only').text().replace(/\$/g, ''),
          'King Single (107 x 204 cm)': $('.king-single-mattress-only').text().replace(/\$/g, ''),
          'Double (137 x 188 cm)': $('.double-mattress-only').text().replace(/\$/g, ''),
          'Queen (153 x 204 cm)': $('.queen-mattress-only').text().replace(/\$/g, ''),
          'King (183 x 204 cm)': $('.king-mattress-only').text().replace(/\$/g, ''),
          'Split King (184 x 204 cm)': $('.split-king-mattress-only').text().replace(/\$/g, ''),
          'Double (138 x 188 cm)': $('.nz-double-mattress-only').text().replace(/\$/g, ''),
          'Queen (153 x 203 cm)': $('.nz-queen-mattress-only').text().replace(/\$/g, ''),
          'King (168 x 203 cm)': $('.nz-king-mattress-only').text().replace(/\$/g, ''),
          'Super King (183 x 203 cm)': $('.super-king-mattress-only').text().replace(/\$/g, ''),
          'Super King - Split (Velcro join - 183 x 203 cm)': $('.super-king-split-mattress-only').text().replace(/\$/g, ''),
          'Super King - Split (Zip join - 183 x 203 cm)': $('.super-king-split-mattress-only').text().replace(/\$/g, ''),
        };
      }

      if (dreamBedChoice in prices) {
        const selectedPrice = prices[dreamBedChoice];
        const calculatedTotalPrice = selectedPrice * parseInt(quantity);

        // Format the price with a comma separator
        const formattedPrice = formatPriceWithComma(calculatedTotalPrice);
        totalPrice.text('$' + formattedPrice);
        totalPriceValue.val('$' + formattedPrice);
      }
    };

    // Dreambeds total price
    const totalPriceWrapper = $('form.wpcf7-form .dreambeds-total-price-wrapper');
    if (totalPriceWrapper.length) {
      const bed = $('form.wpcf7-form select[name="bed"]');
      const quantity = $('form.wpcf7-form select[name="qty"]');
      const quantityCustomText = $('.qty .select2-selection__rendered');
      const type = $('form.wpcf7-form input[type="radio"][name="radio-437"]');

      // Clear quantity and set defaults when dream bed choice changes
      bed.on('select2:select', function() {
        quantity.val('');
        quantityCustomText.attr('title', 'Quantity*').text('Quantity*');
        totalPriceWrapper.removeClass('show');
      });

      quantity.on('select2:select', function() {
        const _this = $(this).val();
        const dreamBed = bed.val();

        if (_this !== '' && dreamBed !== '') {
          totalPriceWrapper.addClass('show');
          calculateBedPrice(dreamBed, _this);
        } else {
          totalPriceWrapper.removeClass('show');
        }
      });

      type.on('change', function() {
        quantity.val('');
        quantityCustomText.attr('title', 'Quantity*').text('Quantity*');
        totalPriceWrapper.removeClass('show');
      });
    }
  });
};

export default dreamBedsForm;



// WEBPACK FOOTER //
// ./scripts/routes/modules/dreamBedsForm.js